import React, { useState } from "react";
import { FaRegEye } from "react-icons/fa";
import equifax from "../../assets/img/logo/equifax.png";
import experian from "../../assets/img/logo/experian.png";
import trasUnion from "../../assets/img/logo/trasUnion.png";
import FileUploader from "../fileUploader/FileUploader";

const cardData = {
  trasUnion: [
    {
      id: 1,
      title: "TransUnion: Collections Dispute (Round 1)",
      pages: "4 Pages",
      buttons: ["DELETED", "NO RESPONSE", "VERIFIED"],
    },
    {
      id: 2,
      title: "Equifax: Identity Theft (Round 2)",
      pages: "3 Pages",
      buttons: ["DELETED", "NO RESPONSE", "VERIFIED"],
    },
    {
      id: 3,
      title: "TransUnion: Credit Report Update",
      pages: "5 Pages",
      buttons: ["DELETED", "NO RESPONSE", "VERIFIED"],
    },
    {
      id: 4,
      title: "TransUnion: Late Payment Removal",
      pages: "2 Pages",
      buttons: ["DELETED", "NO RESPONSE", "VERIFIED"],
    },
  ],
  equifax: [
    {
      id: 1,
      title: "Equifax: Collections Dispute (Round 1)",
      pages: "4 Pages",
      buttons: ["DELETED", "NO RESPONSE", "VERIFIED"],
    },
    {
      id: 2,
      title: "Equifax: Identity Theft (Round 2)",
      pages: "3 Pages",
      buttons: ["DELETED", "NO RESPONSE", "VERIFIED"],
    },
    {
      id: 3,
      title: "Equifax: Credit Report Update",
      pages: "5 Pages",
      buttons: ["DELETED", "NO RESPONSE", "VERIFIED"],
    },
    {
      id: 4,
      title: "Equifax: Late Payment Removal",
      pages: "2 Pages",
      buttons: ["DELETED", "NO RESPONSE", "VERIFIED"],
    },
  ],
  experian: [
    {
      id: 1,
      title: "Experian: Collections Dispute (Round 1)",
      pages: "4 Pages",
      buttons: ["DELETED", "NO RESPONSE", "VERIFIED"],
    },
    {
      id: 2,
      title: "Experian: Identity Theft (Round 2)",
      pages: "3 Pages",
      buttons: ["DELETED", "NO RESPONSE", "VERIFIED"],
    },
    {
      id: 3,
      title: "Experian: Credit Report Update",
      pages: "5 Pages",
      buttons: ["DELETED", "NO RESPONSE", "VERIFIED"],
    },
    {
      id: 4,
      title: "Experian: Late Payment Removal",
      pages: "2 Pages",
      buttons: ["DELETED", "NO RESPONSE", "VERIFIED"],
    },
  ],
  adLetters: [
    {
      id: 1,
      title: "Experian: Collections Dispute (Round 1)",
      pages: "4 Pages",
      fileUpload: <FileUploader />,
    },
    {
      id: 2,
      title: "Experian: Identity Theft (Round 2)",
      pages: "3 Pages",
      buttons: ["DELETED", "NO RESPONSE", "VERIFIED"],
    },
    {
      id: 3,
      title: "Experian: Credit Report Update",
      pages: "5 Pages",
      buttons: ["DELETED", "NO RESPONSE", "VERIFIED"],
    },
    {
      id: 4,
      title: "Experian: Late Payment Removal",
      pages: "2 Pages",
      buttons: ["DELETED", "NO RESPONSE", "VERIFIED"],
    },
  ],
};

export default function ReviewSendDashboard() {
  const [selectedButtons, setSelectedButtons] = useState({});
  const [visibleCards, setVisibleCards] = useState({
    trasUnion: 3,
    equifax: 3,
    experian: 3,
    adLetters: 3,
  });

  const handleButtonClick = (cardId, buttonLabel) => {
    setSelectedButtons((prevSelectedButtons) => ({
      ...prevSelectedButtons,
      [cardId]: buttonLabel,
    }));
  };

  const handleViewAll = (category) => {
    setVisibleCards((prevVisibleCards) => ({
      ...prevVisibleCards,
      [category]: cardData[category].length,
    }));
  };

  const handleViewLess = (category) => {
    setVisibleCards((prevVisibleCards) => ({
      ...prevVisibleCards,
      [category]: 3,
    }));
  };

  const renderCardList = (data, category) => {
    const visibleData = data.slice(0, visibleCards[category]);
    return visibleData.map((card) => (
      <div className="row_list" key={card.id}>
        <div className="text_area">
          <h4>{card.title}</h4>
          <p>{card.pages}</p>
        </div>
        <div className="select_btn_area">
          {card.fileUpload && (
            <div className="file-upload">{card.fileUpload}</div>
          )}
          {card.buttons &&
            card.buttons.map((buttonLabel, index) => (
              <button
                key={index}
                className={`btn ${
                  selectedButtons[`${category}-${card.id}`] === buttonLabel
                    ? "selected"
                    : ""
                }`}
                onClick={() =>
                  handleButtonClick(`${category}-${card.id}`, buttonLabel)
                }
              >
                {buttonLabel}
              </button>
            ))}
        </div>
        <button>
          <FaRegEye className="icons" />
        </button>
      </div>
    ));
  };

  return (
    <div className="review_send_dashboard mt-4">
      <div className="row">
        <div className="col-lg-6">
          <div className="card">
            <h3>Mail it Yourself</h3>
            <ul className="item_menu">
              <li>
                <input type="checkbox" />
                <p>Printed & Mailed For You</p>
              </li>
            </ul>
            <button className="btn">Select</button>
          </div>
        </div>
        <div className="col-lg-6">
          <div className="card">
            <h3>Auto Mailing</h3>
            <ul className="item_menu">
              <li>
                <input type="checkbox" />
                <p>Printed & Mailed For You</p>
              </li>
              <li>
                <input type="checkbox" />
                <p>Secure & High Quality</p>
              </li>
              <li>
                <input type="checkbox" />
                <p>Guaranteed Delivery</p>
              </li>
            </ul>
            <button className="btn">Select</button>
          </div>
        </div>
      </div>
      <div className="brand_card_list mt-4">
        <div className="ov_card">
          <div className="card">
            <div className="card_header">
              <img src={trasUnion} alt="TransUnion" />
            </div>
            {renderCardList(cardData.trasUnion, "trasUnion")}
            <div className="p-3 pt-0">
              {visibleCards.trasUnion < cardData.trasUnion.length ? (
                <button
                  onClick={() => handleViewAll("trasUnion")}
                  className="btn btn_s"
                >
                  View All
                </button>
              ) : (
                <button
                  onClick={() => handleViewLess("trasUnion")}
                  className="btn btn_s"
                >
                  View Less
                </button>
              )}
            </div>
          </div>
        </div>
        <div className="ov_card">
          <div className="card">
            <div className="card_header">
              <img src={equifax} alt="Equifax" />
            </div>
            {renderCardList(cardData.equifax, "equifax")}
            <div className="p-3 pt-0">
              {visibleCards.equifax < cardData.equifax.length ? (
                <button
                  onClick={() => handleViewAll("equifax")}
                  className="btn btn_s"
                >
                  View All
                </button>
              ) : (
                <button
                  onClick={() => handleViewLess("equifax")}
                  className="btn btn_s"
                >
                  View Less
                </button>
              )}
            </div>
          </div>
        </div>
        <div className="ov_card">
          <div className="card">
            <div className="card_header">
              <img src={experian} alt="Experian" />
            </div>
            {renderCardList(cardData.experian, "experian")}
            <div className="p-3 pt-0">
              {visibleCards.experian < cardData.experian.length ? (
                <button
                  onClick={() => handleViewAll("experian")}
                  className="btn btn_s"
                >
                  View All
                </button>
              ) : (
                <button
                  onClick={() => handleViewLess("experian")}
                  className="btn btn_s"
                >
                  View Less
                </button>
              )}
            </div>
          </div>
        </div>
        <div className="ov_card">
          <div className="card">
            <div className="card_header">
              <h3>Additional Letters</h3>
            </div>
            {renderCardList(cardData.adLetters, "adLetters")}
            <div className="p-3 pt-0">
              {visibleCards.adLetters < cardData.adLetters.length ? (
                <button
                  onClick={() => handleViewAll("adLetters")}
                  className="btn btn_s"
                >
                  View All
                </button>
              ) : (
                <button
                  onClick={() => handleViewLess("adLetters")}
                  className="btn btn_s"
                >
                  View Less
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
      <div className="btn_group">
        <button className="btn next-button" onClick={() => alert("Submitted!")}>
          Reset Everything
        </button>
      </div>
    </div>
  );
}
